import React from 'react'
import styled from 'styled-components'

const Styling = styled.div`
    .textBlock{
    width:100%;
    margin-bottom: 4rem;

        &[data-width="hundred"]{
        width: 100%;
        }
        
        &[data-width="fifty"]{
        width: 100%;

            @media only screen and (min-width: 1024px) {
            width: 50%;
            }

        }

        ${({theme}) => theme.textStyling()}  
    }
`

export { Styling }